import React from 'react';
import Jibber from '/app/src/jibber'
import {connect} from 'react-redux';
import {Flex, SVGButton, ToogleSwitch, SVG, Spinner} from '/app/src/component';
import style from './style.css'
import {SortableContainer, SortableElement, arrayMove} from 'react-sortable-hoc'
import AddCategoryModal from './AddCategoryModal'
import {FAQModel, FeedbackModel, CustomizationModel} from '/app/src/model'

import {CustomizationSelector} from '/app/src/model/selectors'
import {history} from '/app/src/store'
import EditCategoriModal from './EditCategoryModal';
import Theme from '/app/src/theme';

import _ from 'lodash'


class Category extends Jibber{
    constructor(props){
        super(props)
        this.useState({
            hoverOpacity: '1',
            showDragnDrop: false,
        })
    }

    render(){
        const {item, isEdit, updateDirtyItem} = this.props
        const {hoverOpacity} = this.state
        const visible = item.visible

        const imgSrc=`https://storage.googleapis.com/jibber-image/images/${item.imgSrc}`

        const visibleStyle = {position: 'absolute', 'fill': '#2ea2d2', 'left': '10px', top: '5px',
            'height': '26px', 'width': '26px'}
        const editStyle = {position: 'absolute', 'fill': '#2ea2d2', 'right': '10px', top: '5px',
            'height': '26px', 'width': '26px', zIndex: 100}
        const dragnDropStyle = {position: 'absolute', 'fill': '#2ea2d2'}

        let visibleImg = visible?'/images/Visible.svg':'/images/Hidden.svg';
        let visibleColor = visible?'':'#898989';

        return (
            <Flex w='200px' h='200px' column center
                backgroundHover='darkwhite'
                opacity={visible?1:0.6}
                borderRadius='20px' position='relative'
                cursor='pointer'
                userSelect='none'
                onMouseEnter={() => {
                    if(!this.props.isEdit) return;
                    this.setHoverOpacity('0.2')
                    this.setShowDragnDrop(true)
                }}
                onMouseLeave={() => {
                    this.setHoverOpacity('1')
                    this.setShowDragnDrop(false)
                }}
                onClick={()=>{
                    if(this.props.isEdit) return;
                    history.push('/clientChat/faq/helpdesk/category/'+item.id)
                }}>

            {(!visible || this.props.isEdit) &&
            <SVGButton
                cacheGetRequests={true}
                style={visibleStyle}
                color={visibleColor}
                src={visibleImg}
                onClick={() => {
                    if(!isEdit) return;
                    updateDirtyItem(item.id, {visible: !visible})
                }}
            />
            }

            {this.props.isEdit &&
            <SVGButton cacheGetRequests={true} style={editStyle}
                src='/images/Edit_M.svg'
                onClick={() =>{
                    this.props.onCategoryEditClick()
                    this.props.editItemClick(item)
                }}
            />
            }
            {(this.state.showDragnDrop && this.props.isEdit) &&
            <SVGButton height='90px' width='90px' cacheGetRequests={true} cursor='grap'
                style={dragnDropStyle} src='/images/DragnDrop.svg'/>
            }
            <SVG  cacheGetRequests={true} style={{'fill': '#2ea2d2', 'height': '94px', 'width': '94px', opacity: hoverOpacity}}
                src={imgSrc}/>

            <Flex className={style.CategoryTitle } color='#6c6c6c' fontSize='24px' fontWeight='300' marginTop='5px' hoverOpacity={hoverOpacity} hAlignContent='center' userSelect='none' hyphens='auto'>
                <div className='ellipsis'>
                    {this.props.item.category}
                </div>
            </Flex>
        </Flex>
    )}
}

class CategoriesMain extends Jibber {
    constructor(props){
        super(props)
        this.useState({
            'openAddModal': false,
            'openEditModal': false,
            'editItem': {},
            'isEdit': false,
            'activeSaveButton': false,

            'categories': _.sortBy(props.categories, ['order']),
            'dirty': {},
            nbrUnread: 0,
            fillColor: 'grey1',

        })
        this.renderCategoryView = this.renderCategoryView.bind(this)
        this.onSortEnd = this.onSortEnd.bind(this)
        this.onSaveButtonClick = this.onSaveButtonClick.bind(this)
        this.updateDirtyItem = this.updateDirtyItem.bind(this)
        this.getNbrUnread = this.getNbrUnread.bind(this);
    }

    componentDidUpdate(prevProps, prevState){
        if(prevState.isEdit === true && this.state.isEdit === false){
            if (_.size(this.state.dirty)>0){
                this.setDirty({})
                this.props.dispatchGetCategories()
                const categories = _.sortBy(this.props.categories, ['order'])
                this.setCategories(categories)
                return
            }
        }
        if(prevProps.categories !== this.props.categories){
            const categories = _.sortBy(this.props.categories, ['order'])
            this.setCategories(categories)
        }
    }


    componentDidMount(){
        this.props.currentItemDispatcher(null);
        const categories = _.sortBy(this.props.categories, ['order']);
        this.props.getUnread('helpdesk', this.getNbrUnread);

        this.setCategories(categories)
    }

    updateDirtyItem(itemId, updates){
        let categories = this.state.categories

        const itemIndex = _.findIndex(this.state.categories, (c)=>{
            return c.id === itemId
        })

        categories[itemIndex] = {...categories[itemIndex], ...updates}
        this.setCategories(categories)

        let dirty = this.state.dirty
        dirty[itemId] = true
        this.setDirty(dirty)
        this.setActiveSaveButton(true)
    }

    onSortEnd({oldIndex, newIndex}){
        let newSortedLists = arrayMove(this.state.categories, oldIndex, newIndex)
        for(var index in newSortedLists){
            let item = newSortedLists[index]
            if(parseInt(item.order, 10) !== parseInt(index, 10)){
                newSortedLists[index].order = index
                let dirty = this.state.dirty
                dirty[item.id] = true
                this.setDirty(dirty)
            }
        }
     this.setState({categories: newSortedLists})
     this.setActiveSaveButton(true)
    }

    onSaveButtonClick(){
        var payload = []
        _.each(this.state.dirty,(tmp, itemId)=>{
            const item = _.find(this.state.categories, (c)=>{
                return c.id === parseInt(itemId, 10)
            })
            if(item) {
                payload.push({
                    'id': itemId,
                    'updates': _.omit(item, 'id')
                })
            }
        })
        if(payload.length){
            this.props.updateCategories(payload)
        }

        this.setActiveSaveButton(false);
        this.setIsEdit(false)
    }

    renderCategoryView(){
        const SortableCategory = SortableElement(({item, isEdit, onCategoryEditClick, editItemClick, setUpdateData}) => {
            return (
                <li className={style.CategoriesItem}>
                    <Category
                        item={item}
                        isEdit={this.state.isEdit}
                        onCategoryEditClick={onCategoryEditClick}
                        editItemClick={editItemClick}
                        updateDirtyItem={this.updateDirtyItem}
                    />
                </li>
            )}
        )
        const OCategory = (
            <li className={style.CategoriesItem}>
                <Category
                    item={{
                        'id': 0,
                        'visible': false,
                        'category': 'Okategoriserat',
                        'imgSrc': 'HelpdeskCategories_Questions_L.svg'
                    }}
                    isEdit={false}
                    onCategoryEditClick={()=>{}}
                    editItemClick={()=>{}}
                    updateDirtyItem={()=>{}}
                />
            </li>
        )
        const AddNewCategoryButton = (
            <li className={style.CategoriesItem}>
                  <Flex w='200px' h='200px' column center
                      backgroundColor='darkwhite' backgroundHover='#e5e5e5'
                      borderRadius='20px' cursor='pointer'
                      onClick={()=>this.setOpenAddModal(true)}>
                      <Flex color='darkgrey' fontSize='111px' fontWeight='300' marginTop='5px'>
                          +
                      </Flex>
                  </Flex>
            </li>
        )
        const SortableList = SortableContainer(({items}) => {
            return (
                <ul className={style.CategoriesContainer}>
                    {items.map((category, index) => (
                      <SortableCategory
                          key={`item-${category.id}`}
                          index={parseInt(category.order, 10)} imgSrc={category.imgSrc}
                          item={category} isEdit={this.state.isEdit} disabled={!this.state.isEdit}
                          onCategoryEditClick={() =>this.setOpenEditModal(true)}
                          editItemClick={(item) =>this.setEditItem(item)}
                      />
                    ))}
                    {this.props.ocategorySize !== 0 && OCategory}
                    {items.length < 17 &&
                        AddNewCategoryButton
                    }
                </ul>
          )
      });

      return  <SortableList items={this.state.categories}
                axis='xy' distance={5}
                onSortEnd={this.onSortEnd}/>
    }

    getNbrUnread(nbrUnread){
        if(this.state.nbrUnread !== nbrUnread && nbrUnread < 100){
            this.setState({
                nbrUnread: nbrUnread
            })
        }

    }

    render(){
        const props = this.props;
        const {nbrUnread, fillColor} = this.state;
        if(!props.network.fetched && props.network.fetching){
            return <Spinner/>
        }
        const {openAddModal, openEditModal, editItem, activeSaveButton} = this.state;
        const {setOpenAddModal, setOpenEditModal, setIsEdit, setActiveSaveButton} = this;

        let SaveButton =  <SVGButton text='Spara' src='/images/Save.svg'
                            border borderRadius='30px'
                            color='lightgrey'
                            fontWeight='500' fontSize='21px'
                            px='4px' cursor='default'/>

        if(activeSaveButton){
            SaveButton = <SVGButton text='Spara' src='/images/Save.svg'
                            border borderRadius='30px'
                            color='black'
                            fontWeight='500' fontSize='21px'
                            px='4px' hover='blue'
                            onClick={this.onSaveButtonClick}/>
        }
        const CancelButton = <SVGButton text='Avbryt' src='/images/Return.svg'
                                border borderRadius='30px' px='4px'
                                fontWeight='500' fontSize='21px'
                                mr='14px' hover='blue'
                                onClick={()=>{
                                    this.setIsEdit(false)
                                    this.setActiveSaveButton(false)
                                }}/>

        const EditButton =  <SVGButton text='Redigera' src='/images/Edit_M.svg'
                            border borderRadius='30px' px='4px'
                            fontWeight='500' fontSize='21px'
                            onClick={()=>{setIsEdit(true)}}/>


        const inboxIcon = <SVG style={{fill: Theme.colors.black}} className={style.Icon} src='/images/HelpdeskPerformance_M.svg' cacheGetRequests={true}/>

        const FeedbackButton = (
            <Flex bg={fillColor}
                onMouseEnter={() => this.setFillColor('#f4fdff')}
                onMouseLeave={() => this.setFillColor('grey1')}
                className={style.NavButton}
                onClick={() => {history.push('/clientChat/faq/helpdesk/feedback/posts')}}>
                <Flex center>
                    {inboxIcon}
                    <Flex fontSize='21px' fontWeight='500'>
                    {'Feedback'}
                    </Flex>
                    {nbrUnread > 0 &&
                        <Flex center className={style.NumberUnread}>
                            {nbrUnread}
                        </Flex>
                    }
                </Flex>
            </Flex>
        )

        return (
            <Flex column w='100%'>
                <Flex center w='100%' px='30px' h='70px' zIndex='1' shrink={0}>
                    <Flex fontWeight='500' fontSize='18px' vAlignContent='center'>
                        <ToogleSwitch on={this.props.faqActive} manual
                            onChange={(e)=>{
                                this.props.setFaqActive(!this.props.faqActive)}
                            }/>
                        <Flex ml='10px'>Aktivera (live)</Flex>
                    </Flex>
                    <Flex center grow borderRadius='30px'>
                        {FeedbackButton}
                    </Flex>
                    {this.state.isEdit &&
                    <Flex mt='15px' mb='15px'>
                        {CancelButton}
                        {SaveButton}
                    </Flex>
                    }
                    {!this.state.isEdit &&
                    <Flex vAlignContent='center' mt='15px' mb='15px'>
                        {EditButton}
                    </Flex>
                    }
                </Flex>
                <Flex w='100%' overflowY='auto' column center overflowX='hidden' paddingTop='10px'>
                    {(this.props.numberVisible > 9) &&
                        <Flex color='lightblack' fontSize='14px' vAlignContent='center' hAlignContent='left' px='30px' py='5px' mt='15px'>
                        *Endast de nio första i listan kommer att visas upp
                        </Flex>
                    }
                    <Flex hAlignContent='center' w='100%' h='100%'>
                        {this.renderCategoryView()}
                    </Flex>
                </Flex>
                <AddCategoryModal
                    open={openAddModal}
                    onClose={()=>setOpenAddModal(false)} />
                <EditCategoriModal
                        open={openEditModal}
                        onClose={() => setOpenEditModal(false)}
                        item={editItem}
                        updateDirtyItem={this.updateDirtyItem}
                        activeSaveButton={() => setActiveSaveButton(true)}
                />
            </Flex>
        )
    }
}


const {dispatcher: dispatchGetCategories} = FAQModel.getCategoriesRequest()
const {selector: categoriesSelector} = FAQModel.getCategoriesRequest()
const {dispatcher: removeCategory} = FAQModel.removeCategoryRequest()
const {dispatcher: updateCategoriesDispatch, selector: updateCategorieSelector} = FAQModel.updateCategoriesRequest()
const {dispatcher: updateCustomizationDispatch} = CustomizationModel.updateRequest()
const { dispatcher: currentItem } = FAQModel.setCurrentItem();
const {dispatcher: getUnread} = FeedbackModel.getUnread();


const mapDispatchToProps = (dispatch, props) => ({
    'dispatchGetCategories': ()=>dispatch(dispatchGetCategories()),
    removeCategory: ()=>dispatch(removeCategory()),
    updateCategories: (categories) => dispatch(updateCategoriesDispatch(categories)),
    setFaqActive: (isActive) => dispatch(updateCustomizationDispatch({faq_on:isActive})),
    currentItemDispatcher: (id) => dispatch(currentItem(id)),
    getUnread: (systemType, callback) => dispatch(getUnread(systemType, callback))

})

function mapStateToProps(state, props){
    const {network, categories} = categoriesSelector(state)
    const faqActive = CustomizationSelector.getFaqActive(state)
    const updateNetwork = updateCategorieSelector(state)['network'].toJS()
    const ocategorySize = FAQModel.selector.getFAQByCategoriesId(state, 0).size
    const numberVisible = FAQModel.selector.getVisibleItems(categories.toJS()).length

    return {
        network: network.toJS(),
        categories: categories.toJS(),
        faqActive,
        updateNetwork,
        ocategorySize,
        numberVisible
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(CategoriesMain)



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/FAQ/Helpdesk/Categories/index.js